<script>
  import { onMount } from 'svelte';
  import { MDCTextField } from '@material/textfield';
  import { fly } from 'svelte/transition';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../translate.js';
  import { parse_time_value } from '../utils';

  export let id;
  export let label;
  export let value;
  export let disabled = false;
  export let variant = 'outlined';
  export let min;
  export let max;
  export let name;
  export let valid = true;
  export let invalid_text;
  export let selecting = false;
  export let active_id;
  export let height;
  export let width;
  export let disabled_dark = false;
  export let is_end_date = false;
  export let is_required = false;

  let text_field;
  let has_field_init = false;
  let focus = false;
  let has_init = true;
  let matrix_days = [];


  let week_days;
  let current_month;
  let current_year;
  let current_day;
  let actual_month;
  let actual_year;
  let actual_day;
  let month_names = [];
  let mouse_over = false;
  let input_value = null;


  const init_selector = () => {
    let element = document.getElementById(`${id}-date`);
    text_field = new MDCTextField(element);
    has_init = true;

    let date = new Date();
    actual_month = date.getMonth();
    current_day = date.getDate();
    actual_day = date.getDate();
    current_month = date.getMonth();
    current_year = date.getFullYear();
    actual_year = date.getFullYear();
    matrix_days = get_matrix_for_the_month(current_month, current_year);

    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_JAN));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_FEB));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_MAR));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_APR));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_MAY));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_JUN));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_JUL));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_AUG));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_SEP));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_OCT));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_NOV));
    month_names.push(t9n(TS.SETTINGS_LABEL_MONTH_DEC));

    week_days = t9n(TS.CALENDAR_DAYS);
    week_days = week_days.split(", ");
    // week_days = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

    document.getElementById(id).addEventListener('keydown', (e) => {
      if (e.keyCode === 8) {
        value = '';
        input_value = '';
        e.preventDefault();
      }
    });
  };


  const field_on_click = () => {
    if (focus && !selecting) selecting = true;
  };

  const on_focus = () => {

    if (!focus) {

      focus = !focus;
      active_id = id;
      has_field_init = false;
      if (!selecting && focus) selecting = true;
      if (selecting && !focus) selecting = false;

      if (!!value) {
        let date = new Date(value);
        actual_month = date.getMonth();
        current_day = date.getDate();
        current_month = date.getMonth();
        current_year = date.getFullYear();
        matrix_days = get_matrix_for_the_month(current_month, current_year);
      }
    } else{
      if(selecting && !mouse_over) selecting = false;
    }

    // if(focus && selecting){
    //   focus = false;
    //   selecting = false;
    // }

  };

  const days_in_month = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const get_day_in_week = (day, month, year) => {
    let val = new Date(year, month, day).getDay();
    return val === 0 ? 7 : val;
  };

  const select_date = (day, month) => {
    let tmp_month = month + 1;
    if(tmp_month < 10) tmp_month = `0${tmp_month}`;
    let tmp_day = day;
    if(tmp_day < 10) tmp_day = `0${tmp_day}`;


    if(tmp_month === 13){
      current_year++;
      tmp_month = '01';
    }

    if(tmp_month === '00'){
      current_year--;
      tmp_month = '12';
    }

    value = `${current_year}-${tmp_month}-${tmp_day}`;

    input_value = `${tmp_day}-${tmp_month}-${current_year}`;
    focus = false;
    selecting = false;
  };

  const get_matrix_for_the_month = (month, year) => {
    let days = days_in_month(month, year);
    let matrix = [];
    for (let i = 1; i <= days; i++) {
      matrix.push({
        date: i,
        day_of_week: get_day_in_week(i, month, year),
        month: month,
      });
    }


    let days_last_month = days_in_month(month - 1, year);
    let shift = matrix[0].day_of_week;
    if (shift > 1) {
      for (let i = days_last_month; i > days_last_month - shift + 1; i--) {
        matrix.unshift({
          date: i,
          day_of_week: get_day_in_week(i, month - 1, year),
          month: month - 1,
        });
      }
    }


    let last = matrix[matrix.length - 1].day_of_week;
    let next_days = 7 - last + 7;

    if (matrix.length + next_days < 42) {
      next_days += 42 - matrix.length - next_days;
    }

    for (let i = 1; i <= next_days; i++) {
      matrix.push({
        date: i,
        day_of_week: get_day_in_week(i, month + 1, year),
        month: month + 1,
      });
    }


    if(is_end_date){
      matrix.forEach(e => {
        let month = parse_time_value(Number(e.month));
        let date = parse_time_value(Number(e.date));
        let min_date = new Date(min);
        let matrix_date = new Date(`${year}-${month}-${date}`);
        e.disabled = matrix_date < min_date;
      });
      // console.log('matrix', matrix);
    }

    return matrix;
  };

  const next_month = () => {
    current_month++;
    if (current_month === 12) {
      current_month = 0;
      current_year++;
    }
    matrix_days = get_matrix_for_the_month(current_month, current_year);
  };

  const prev_month = () => {
    current_month--;
    if (current_month === -1) {
      current_month = 11;
      current_year--;
    }
    matrix_days = get_matrix_for_the_month(current_month, current_year);
  };

  $: if (!!value && has_init && !has_field_init) {
    let date = new Date(value);
    current_day = date.getDate();
    current_month = date.getMonth();
    current_year = date.getFullYear();
    matrix_days = get_matrix_for_the_month(current_month, current_year);
    let tmp_month = current_month + 1;
    if(tmp_month < 10) tmp_month = `0${tmp_month}`;
    let tmp_day = current_day;
    if(tmp_day < 10) tmp_day = `0${tmp_day}`;
    input_value = `${tmp_day}-${tmp_month}-${current_year}`;
    has_field_init = true;
  }

  $: if(!value){
    input_value = null;
    has_field_init = false;
  }

  onMount(init_selector);
</script>


<div class='position-relative' id={id} class:disabled-dark={disabled_dark}>
  {#if variant === 'filled'}
    <label
      id={`${id}-date`}
      class:disabled-bg={disabled}

      class='mdc-text-field mdc-text-field--filled mdc-text-field--with-trailing-icon'
      class:mdc-text-field--invalid={!valid && selecting}
      class:mdc-text-field--disabled={disabled}
      class:mdc-text-field--label-floating={has_field_init}
      style={`height: ${height}; width: ${width}`}>
      <span class='mdc-text-field__ripple' />
      <span
        class='mdc-floating-label'
        id={`${id}-label`}
        class:mdc-floating-label--float-above={has_field_init}>
        {label} {#if is_required}*{/if}
      </span>
      <i
        class='material-icons mdc-text-field__icon mdc-text-field__icon--trailing'>event</i>

      <input
        readonly='readonly'
        id={`${id}-input`}
        class='mdc-text-field__input'
        type='text'
        autocomplete='off'
        {name}
        {min}
        {max}
        aria-labelledby={`${id}-label`}
        on:focus={on_focus}

        on:click={field_on_click}
        bind:value={input_value}
        {disabled} />
      <span class='mdc-line-ripple' />
    </label>
  {:else}
    <label
      id={`${id}-date`}
      class:disabled-bg={disabled && !disabled_dark}
      class='mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon'
      class:mdc-text-field--invalid={!valid}
      class:mdc-text-field--disabled={disabled && !disabled_dark}
      class:mdc-text-field--label-floating={has_field_init}
      style={`height: ${height}; width: ${width}`}>
      <span class='mdc-notched-outline'>
        <span class='mdc-notched-outline__leading' />
        <span class='mdc-notched-outline__notch'>
          <span
            class='mdc-floating-label'
            id={`${id}-label`}
            class:mdc-floating-label--float-above={has_field_init}>
            {label} {#if is_required}*{/if}
          </span>
        </span>
        <span class='mdc-notched-outline__trailing' />
      </span>
      <i class='material-icons mdc-text-field__icon'
      class:material-icons-disabled={disabled}>event</i>
      <input
        readonly='readonly'
        autocomplete='off'
        id={`${id}-input`}
        class='mdc-text-field__input'
        type='text'
        {name}
        {min}
        {max}
        aria-labelledby={`${id}-label`}
        on:focus={on_focus}
        on:blur={on_focus}
        on:click={field_on_click}
        bind:value={input_value}
        {disabled} />
    </label>
  {/if}

  {#if selecting}
    <div
      id={`${id}-options`}
      class='list-container'
      on:mouseover={() => mouse_over = true}
      on:mouseout={() => mouse_over = false}
      transition:fly={{ y: -50, duration: 250 }}
      class:container-style-outlined={variant === 'outlined'}
      class:container-style-filled={variant === 'filled'}
      class:container-style-filled-valid={variant === 'filled' && valid}
      class:container-style-outlined-invalid={variant === 'outlined' && !valid}
      class:container-style-filled-invalid={variant === 'filled' && !valid}>
      <div class='mdc-layout-grid' style='margin: 0; padding: 0;'>
        <div class='mdc-layout-grid__inner'>
          <div class='mdc-layout-grid__cell' style='display: flex; margin-left: 10px;'>
            <p style='margin-right: 5px;'>{month_names[current_month]}</p>
            <p>{current_year}</p>
          </div>
          <div class='mdc-layout-grid__cell'>
            <div style='margin-top: 13px; margin-right: -15px; display: flex; justify-content: flex-end'>


              <!--{#if actual_month === current_month && actual_year === current_year}-->
              <!--  <i class='material-icons disabled-icon'>arrow_upward</i>-->
              <!--{:else}-->
                <i class='material-icons' on:click={prev_month}>arrow_upward</i>
              <!--{/if}-->
              <i class='material-icons' on:click={next_month}>arrow_downward</i>

            </div>
          </div>
        </div>
      </div>


      <div style='display: flex; justify-content: center'>
        <div class='calendar-table'>

          {#each week_days as item, index}
            <div class='calendar-box'>{item}</div>
          {/each}
          {#each matrix_days as item, index}
            <!--{#if item.month <= actual_month && actual_year === current_year && item.date < actual_day}-->
            <!--  <div class='calendar-box disabled-day'>-->
            <!--    <p>{item.date}</p>-->
            <!--  </div>-->
            <!--{:else if item.month < actual_month && actual_year === current_year}-->
            <!--  <div class='calendar-box disabled-day'>-->
            <!--    <p>{item.date}</p>-->
            <!--  </div>-->
            <!--{:else}-->
              <div
                class='calendar-box'
                on:click={select_date(item.date, item.month)}
                on:mouseover={() => mouse_over = true}
                class:calender-current_day={item.date === current_day && item.month === actual_month}
                class:calendar-not_current={item.date !== current_day && item.month === current_month}
                class:calender-other-month={item.month !== current_month}>
                <p>{item.date}</p>
              </div>
            <!--{/if}-->

          {/each}
        </div>
      </div>
    </div>
  {/if}

  {#if !valid}
    <div class='tooltip-error'>
      <span
        class='tooltip-text tooltip-top'
        id={`${id}-invalid`}>{invalid_text}</span>
    </div>
  {/if}
</div>

<style>

    .disabled-dark .material-icons-disabled{
        color: black !important;
    }
    .disabled-dark .mdc-text-field--disabled .mdc-text-field__input {
        color: black !important;
    }
    .mdc-text-field--outlined .mdc-floating-label {
        background-color: white !important;
    }
    .calendar-box p {
        margin-top: 4.1px;
    }

    .mdc-button {
        min-width: 35px !important;
    }

    .disabled-day {
        cursor: default !important;
        color: #c4c4c4 !important;
    }

    .disabled-icon {
        cursor: default !important;
        color: #a3a3a3 !important;
    }

    .disabled-icon:hover {
        background-color: white !important;
    }

    .material-icons-disabled {
      color: #b1b1b1 !important;
    }

    .material-icons {
        cursor: pointer;
        border-radius: 5px;
    }

    .material-icons:hover {
        background-color: rgba(0, 102, 153, 0.25);
        border-radius: 5px;
    }

    .calendar-box {
        width: 25.7px;
        height: 25.7px;
        vertical-align: middle;
        text-align: center;
        display: table-cell;
        float: left;
        font-size: 10pt;
        border-radius: 5px;
    }

    .calendar-not_current {
        cursor: pointer;
    }

    .calendar-not_current:hover {
        background-color: rgba(0, 102, 153, 0.25);
    }

    .calender-current_day {
        background-color: #006699;
        color: white;
        cursor: pointer;
    }

    .calender-other-month {
        color: #a3a3a3;
        cursor: pointer;
    }

    .calender-other-month:hover {
        background-color: rgba(0, 102, 153, 0.25);
    }

    .calendar-table {
        width: 180px;
    }

    .material-icons {
        color: black;
    }

    input {
        cursor: text;
    }

    .disabled-bg {
        opacity: 0.5;
        transition: all 0.2s ease-in-out;
    }

    .mdc-text-field {
        width: inherit;
        transition: all 0.2s ease-in-out;
    }

    .mdc-text-field--with-trailing-icon.mdc-text-field--outlined
    .mdc-text-field__input {
        padding-right: 15px;
    }

    .mdc-text-field--with-trailing-icon .mdc-text-field__input {
        padding-right: 15px;
    }

    .position-relative {
        position: relative;
        width: inherit;
    }

    .tooltip-error {
        position: relative;
        font-size: 12px;
        top: -50px;
        z-index: 12;
    }

    .tooltip-error .tooltip-top {
        position: absolute;
        z-index: 1;
        bottom: 100%;
        left: 50%;
        right: 0;
    }

    .tooltip-error .tooltip-text {
        background-color: var(--invalid-color);
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 8px 8px;
    }

    .list-container {
        position: absolute;
        top: 57px;
        height: 280px;
        width: 99%;
        z-index: 10000;
        overflow-y: hidden;
        overflow-x: hidden;
        box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
        0 5px 8px 0 rgba(0, 0, 0, 0.14), 0 1px 14px 0 rgba(0, 0, 0, 0.12);
    }

    .container-style-outlined {
        background-color: white;
        border-radius: 5px;
    }

    .container-style-outlined-invalid {
        border: 2px solid var(--invalid-color);
    }

    .container-style-filled {
        background-color: #ececec;
        border-radius: 5px;
    }

    .container-style-filled-valid {
        border-bottom: 2px solid #006699;
    }

    .container-style-filled-invalid {
        border-bottom: 2px solid var(--invalid-color);
    }
</style>
